import { marked } from 'marked';

const MD_FILES = import.meta.glob('../content/pages/*.md', {
  eager: true,
  query: '?raw',
  import: 'default',
}) as unknown as Record<string, string>;

export type StaticPageContent = {
  slug: string;
  title: string;
  breadcrumb: string;
  metaDescription: string | null;
  html: string;
};

const FRONTMATTER = /^---\s*\n([\s\S]*?)\n---\s*\n([\s\S]*)$/;

function parseFrontmatter(raw: string): { meta: Record<string, string>; body: string } {
  const m = raw.match(FRONTMATTER);
  if (!m) return { meta: {}, body: raw };
  const meta: Record<string, string> = {};
  for (const line of (m[1] ?? '').split('\n')) {
    const idx = line.indexOf(':');
    if (idx === -1) continue;
    const key = line.slice(0, idx).trim();
    const value = line.slice(idx + 1).trim();
    if (key) meta[key] = value;
  }
  return { meta, body: m[2] ?? '' };
}

const cache = new Map<string, StaticPageContent>();

export function getStaticPage(slug: string): StaticPageContent {
  const hit = cache.get(slug);
  if (hit) return hit;
  const path = `../content/pages/${slug}.md`;
  const raw = MD_FILES[path];
  if (!raw) throw new Error(`Static page not found: ${slug}`);
  const { meta, body } = parseFrontmatter(raw);
  const html = marked.parse(body, { async: false }) as string;
  const result: StaticPageContent = {
    slug,
    title: meta.title ?? slug,
    breadcrumb: meta.breadcrumb ?? meta.title ?? slug,
    metaDescription: meta.metaDescription ?? null,
    html,
  };
  cache.set(slug, result);
  return result;
}
